<div class="auth-wrapper">
  <div *ngIf="loader" id="loader"></div>

  <div class="hero card-glass mb-3">
    <div class="crumb mb-2">
      <a routerLink="/utilisateur/admin/dashboard" class="crumb-link">Retour au dashboard administration</a>
    </div>

    <p class="eyebrow">Spay · Administration</p>
    <h1 class="mb-1">Creation d'un compte membre</h1>
    <p class="lead">Le numero membre est genere automatiquement par le systeme a la creation.</p>
  </div>

  <div *ngIf="successMessage" class="alert alert-success" role="alert">
    {{ successMessage }}
  </div>

  <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
    {{ errorMessage }}
  </div>

  <div class="card card-glass p-3">
    <div class="step-header mb-3">
      <div class="step-titles">
        <div class="step-item" [class.active]="currentStep >= 1" [class.current]="currentStep === 1">
          <span class="step-index">1</span>
          <span class="step-label">Identifiant</span>
        </div>
        <div class="step-item" [class.active]="currentStep >= 2" [class.current]="currentStep === 2">
          <span class="step-index">2</span>
          <span class="step-label">Identite</span>
        </div>
        <div class="step-item" [class.active]="currentStep >= 3" [class.current]="currentStep === 3">
          <span class="step-index">3</span>
          <span class="step-label">Contact</span>
        </div>
        <div class="step-item" [class.active]="currentStep >= 4" [class.current]="currentStep === 4">
          <span class="step-index">4</span>
          <span class="step-label">Documents</span>
        </div>
      </div>
      <div class="step-progress">
        <div class="step-progress-bar" [style.width.%]="stepProgress()"></div>
      </div>
    </div>

    <form [formGroup]="signUp" (ngSubmit)="onSubmit()" class="row g-3">
      <ng-container *ngIf="currentStep === 1">
        <div class="col-md-8">
          <label class="form-label">Numero unique d'identification</label>
          <input formControlName="nidentification" name="nidentification" class="form-control" type="text" required>
          <small *ngIf="nidentification.invalid && (nidentification.dirty || nidentification.touched)" class="text-danger">Champ obligatoire (6 a 40 caracteres)</small>
        </div>
      </ng-container>

      <ng-container *ngIf="currentStep === 2">
        <div class="col-md-6">
          <label class="form-label">Nom</label>
          <input formControlName="firstName" name="firstName" class="form-control" type="text" required>
          <small *ngIf="firstName.invalid && (firstName.dirty || firstName.touched)" class="text-danger">Au moins 2 caracteres</small>
        </div>

        <div class="col-md-6">
          <label class="form-label">Prenom</label>
          <input formControlName="lastName" name="lastName" class="form-control" type="text" required>
          <small *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)" class="text-danger">Au moins 2 caracteres</small>
        </div>
      </ng-container>

      <ng-container *ngIf="currentStep === 3">
        <div class="col-md-6">
          <label class="form-label">Email</label>
          <input formControlName="email" #emaild (blur)="isEmail(emaild.value)" name="email" class="form-control" type="email" required>
          <small *ngIf="email.invalid && (email.dirty || email.touched)" class="text-danger">Email invalide</small>
          <small *ngIf="emailexist && email.valid" class="text-danger">Email deja utilise</small>
        </div>

        <div class="col-md-6">
          <label class="form-label">Numero de telephone</label>
          <input formControlName="phone" #phoned (blur)="isPhone(phoned.value)" name="phone" class="form-control" type="tel" required>
          <small *ngIf="phone.invalid && (phone.dirty || phone.touched)" class="text-danger">Numero invalide</small>
          <small *ngIf="phonexist && phone.valid" class="text-danger">Numero deja utilise</small>
        </div>

        <div class="col-md-6">
          <label class="form-label">Pays</label>
          <select class="form-select" id="pays" formControlName="codePays">
            <option value="237">Cameroun</option>
            <option value="238">Gabon</option>
            <option *ngFor="let p of payslist" [value]="p.code">{{ p.nom }}</option>
          </select>
          <small *ngIf="codePays.invalid && (codePays.dirty || codePays.touched)" class="text-danger">Pays requis</small>
        </div>
      </ng-container>

      <ng-container *ngIf="currentStep === 4">
        <div class="col-12">
          <div class="review-card">
            <h3 class="review-title">Verifier les informations membre</h3>

            <div class="review-grid">
              <div class="review-row"><span>N° identification</span><strong>{{ nidentification.value }}</strong></div>
              <div class="review-row"><span>Nom</span><strong>{{ firstName.value }}</strong></div>
              <div class="review-row"><span>Prenom</span><strong>{{ lastName.value }}</strong></div>
              <div class="review-row"><span>Email</span><strong>{{ email.value }}</strong></div>
              <div class="review-row"><span>Telephone</span><strong>{{ phone.value }}</strong></div>
              <div class="review-row"><span>Code pays</span><strong>{{ codePays.value }}</strong></div>
              <div class="review-row"><span>Numero membre</span><strong>Genere automatiquement</strong></div>
            </div>

            <p class="review-note">Validation admin: creation utilisateur, compte principal, identifiants membre et upload des pieces.</p>
          </div>
        </div>

        <div class="col-12">
          <div class="review-card">
            <h3 class="review-title">Pieces d'identification obligatoires</h3>
            <div class="row g-3">
              <div class="col-md-4">
                <label class="form-label">CNI Recto</label>
                <input type="file" accept="image/*" class="form-control" (change)="onDocumentSelected($event, 'recto')">
                <small class="text-light" *ngIf="selectedRectoName">{{ selectedRectoName }}</small>
              </div>

              <div class="col-md-4">
                <label class="form-label">CNI Verso</label>
                <input type="file" accept="image/*" class="form-control" (change)="onDocumentSelected($event, 'verso')">
                <small class="text-light" *ngIf="selectedVersoName">{{ selectedVersoName }}</small>
              </div>

              <div class="col-md-4">
                <label class="form-label">Photo de profil</label>
                <input type="file" accept="image/*" class="form-control" (change)="onDocumentSelected($event, 'profile')">
                <small class="text-light" *ngIf="selectedProfileName">{{ selectedProfileName }}</small>
              </div>
            </div>
            <small class="text-danger" *ngIf="!isStepFourValid()">Les trois images sont obligatoires.</small>
          </div>
        </div>

        <div class="col-12" *ngIf="provisionedMember">
          <div class="review-card success-card">
            <h3 class="review-title">Identifiants crees</h3>
            <div class="review-grid">
              <div class="review-row"><span>User ID</span><strong>{{ provisionedMember.userId }}</strong></div>
              <div class="review-row"><span>Primary account</span><strong>{{ provisionedMember.primaryAccountNumber }}</strong></div>
              <div class="review-row"><span>Member ID</span><strong>{{ provisionedMember.memberId }}</strong></div>
              <div class="review-row"><span>External account</span><strong>{{ provisionedMember.externalAccountNumber }}</strong></div>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="col-12 d-flex justify-content-between align-items-center mt-2 step-actions">
        <button type="button" class="btn btn-outline-light btn-pill" (click)="previousStep()" [disabled]="currentStep === 1 || loader">
          Precedent
        </button>

        <button type="button" class="btn btn-primary btn-pill" *ngIf="currentStep < totalSteps" (click)="nextStep()" [disabled]="loader">
          Suivant
        </button>

        <button type="submit" class="btn btn-success btn-pill" *ngIf="currentStep === totalSteps" [disabled]="loader || signUp.invalid || phonexist || emailexist || !isStepFourValid()">
          Creer le membre
        </button>
      </div>
    </form>
  </div>
</div>
